const styles = {
  mapPopupContainer: {
    minWidth: 290,
  },
  table: {
    height: "100%",
    width: "100%",
    borderCollapse: "unset"
  },
  spottedTrailerPopupContainer : {
    paddingBottom : 4
  }
};

export default styles;
